import {
  LandingMinimal,
  LandingMinimalHelpsProps
} from '../../../../components/_external-pages/landing';

const props: LandingMinimalHelpsProps = {
  title: 'Oportunidades a tu medida',
  subtitle:
    'Si no cuentas con una propiedad a tu nombre, puedes solicitar \n' +
    'la ayuda de un familiar o amigo que funcionará como garante.',
  subtitleBold: '¡Confiamos en tu proyecto!',
  cards: [
    {
      icon: '/static/icons/ibanIcons/Amount.svg',
      description: 'Obtén desde $100 mil hasta $100 millones',
      title: ''
    },
    {
      icon: '/static/icons/ibanIcons/Term.svg',
      description: 'Plazos de 12 hasta 120 meses',
      title: ''
    },
    {
      icon: '/static/icons/ibanIcons/InterestRate.svg',
      description: 'Tasa desde el 1.5% mensual',
      title: ''
    },
    {
      icon: '/static/icons/ibanIcons/Time.svg',
      description: 'Pre-Aprobación de 24 a 48 hrs',
      title: ''
    },
    {
      icon: '/static/icons/ibanIcons/Credit_bureau.svg',
      description: 'Flexibilidad en buró de crédito',
      title: ''
    },
    {
      icon: '/static/icons/ibanIcons/Personalized_service.svg',
      description: 'Servicio personalizado',
      title: ''
    }
  ]
};

export const HomeCards = () => {
  return <LandingMinimal {...props} />;
};
